import { defineComponent as _defineComponent } from 'vue'
import { ClientInviteState } from 'ah-api-gateways';
import { clientInviteStateLabels } from 'bd-common/src/models/clientInviteState';
import BDStatusPill from 'bd-common/src/components/common/BDStatusPill.vue';

/**
 * Client Invite Status Pill for Bank Direct
 */


export default /*#__PURE__*/_defineComponent({
  __name: 'ClientInviteStatusPill',
  props: {
    status: null
  },
  setup(__props: any) {



const STATUS_COLORS: Record<ClientInviteState, string> = {
  [ClientInviteState.ACTIVE]: 'primary',
  [ClientInviteState.ACCEPTED]: 'success',
  [ClientInviteState.DUE_A_REMINDER]: 'warning',
  [ClientInviteState.CANCELLED]: 'danger',
  [ClientInviteState.DECLINED]: 'danger',
  [ClientInviteState.EXPIRED]: 'danger',
};

return { __sfc: true,STATUS_COLORS, ClientInviteState, clientInviteStateLabels, BDStatusPill }
}

})